import { useMemo } from "react";

import type { ApiError } from "./client";
import type { DiffSide } from "./diffComments";
import { useResource } from "./useResource";

// GET /api/v1/tasks/:id/pr-comments — reviewer comments mirrored back from the
// provider by the PR sync (specifications/diffs-and-pull-requests.md §Reviewer
// experience). Rendered in the diff tab next to local comments, tagged
// "GitHub".
export type ApiPrComment = {
  readonly author_login: string;
  readonly body: string;
  readonly line: number | null;
  readonly occurred_at: string;
  readonly path: string;
  readonly provider_comment_id: string;
  readonly side: DiffSide;
};

export type UsePrComments = {
  readonly comments: ReadonlyArray<ApiPrComment>;
  readonly error: ApiError | undefined;
  readonly loading: boolean;
  readonly refetch: () => void;
};

export const usePrComments = (taskId: string | null): UsePrComments => {
  const { data, error, loading, refetch } = useResource<{
    comments: ReadonlyArray<ApiPrComment>;
  }>(taskId ? `/tasks/${taskId}/pr-comments` : null);
  const comments = useMemo(() => data?.comments ?? [], [data]);
  return { comments, error, loading, refetch };
};
